<template>
	<main class="page-auth" >
		<section class="auth-container">
			<h2>
				{{ $t('users.email_is_verified') }}
			</h2>

			<nice-button-2
					type="button"
					icon="arrow-14"
					:icon-state="-90"
					icon-placement="end"
					icon-painted

					@click="$router.push({name: 'login'})"
			>
				{{ $t('two_factor_auth.enter') | capitalize }}
			</nice-button-2>
		</section>
	</main>
</template>


<script>
export default {
	name: 'EmailVerified',
};

</script>

<style lang="sass" scoped>
main.page-auth
	display: flex
	align-items: center
	justify-content: center

	min-height: 100vh

	h2
		margin: 0 0 10px

	.logo
		width: 27px
		height: 27px
		vertical-align: middle

.auth-container
	margin: 0 auto
	width: 100%
	max-width: 450px
	padding: 60px
	box-sizing: border-box

</style>
